import { graphql } from 'gatsby';
import { Tag } from './BlogTag.styling';

const BLOG_TAG_URL_SLUG = 'blog/tag';

const BlogTag = ({ blogTagElements: { title, url_slug } }: Queries.BLOG_TAGFragment) => (
  <Tag to={`/${BLOG_TAG_URL_SLUG}/${url_slug.value}/`}>{title.value}</Tag>
);

export const fragment = graphql`
  fragment BLOG_TAG on kontent_item_blog_tag {
    __typename
    system {
      id
    }
    blogTagElements: elements {
      title {
        value
      }
      url_slug {
        value
      }
    }
  }
`;

export default BlogTag;
